export default __webpack_public_path__ + "img/exclamation-circle.f65b618e.svg";